import {
  Box
} from "@mui/material";
import { Section } from '../../pages/style';
import { Flex, Label } from "../../style";
import { sizes, utils } from "../../variables";
import AddressField from '../AddressField';
import WordCarousel from "../WordCarousel";
import { Container, ImageContainer } from "./style";

const Banner = ({ mobile }) => {
  return (
    <Container mobile>
      <Flex
        width="100%"
        height="100%"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        gap={sizes.lg}
      >
        <img src="/assets/logo-full.svg" style={{ marginBottom: sizes.lg }} alt="wallverse's logotype" />
        <WordCarousel
          fontSize={sizes.xl2}
          text="A new way of"
          postText="digital art experiences"
          words={["building", "creating", "exploring", "sharing", "building"]}
        />
        <Label fontFamily="Julius Sans One" fontSize={sizes.xl3}>
          digital art experiences
        </Label>
        <Section>
          <Flex justifyContent="center" width={utils.width.full}>
            <ImageContainer>
              <img src="/assets/cta-steps-mobile.svg" width="100%" className="steps-mobile" alt="steps to create wall" />
              <img src="/assets/cta-steps.svg" width="100%" className="steps" alt="steps to create wall" />
            </ImageContainer>
          </Flex>
        </Section>
        <Section alignItems="center" mb="0" mt={sizes.lg}>
          <Box width={1}>
            <AddressField />
          </Box>
        </Section>
        {!mobile && (
          <ImageContainer>
            <picture style={{ width: '100%' }}>
              <source media="(min-width: 768px)" srcSet="/assets/about-gallery-desk.svg" width="100%" alt="Wall of nfts" />
              <source media="(min-width: 425px)" srcSet="/assets/about-gallery-tablet.svg" width="100%" alt="Wall of nfts" />
              <source media="(min-width: 320px)" srcSet="/assets/about-gallery-mobile.svg" width="100%" alt="Wall of nfts" />
              <img src="/assets/about-gallery-desk.svg" style={{ width: '100%' }} alt="Wall of nfts" />
            </picture>
          </ImageContainer>
        )}
      </Flex>
    </Container>
  );
};

export default Banner;
